import { Group, Layout, Page } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { APIS, URLS, SF_SCTN_INFO } from "@/tra/tancis/ptli/usr/sctn/services/PtliSctnService";
import { useEffect } from "react";

/*
 * Edit Section information
 * !== 섹션 정보 수정 ==!
 */
export const PTLI0918004S = () => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0021" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore } = useStore({ pgeUid: pgeUid });
    const modal = useModal();
    const toast = useToast();
    const { cstmOrgzCd } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    const form = {
        sctnInfo: useForm({
            defaultSchema: SF_SCTN_INFO,
        }),
    };

    const fetch = {
        getSctnInfo: useFetch({
            api: () => APIS.getSctnInfo(cstmOrgzCd),
            enabled: !!cstmOrgzCd,
            onSuccess: (data) => {
                // 데이터가 없을 경우
                if (!data.sctnInfo.content) {
                    modal.openModal({ content: "msg.com.00034" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    navigate(`${URLS.ptli0918001q}?menuId=${menuId}`);
                    return;
                }
                form.sctnInfo.setValues(data.sctnInfo.content);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
            showToast: true,
        }),
        updateSctnInfo: useFetch({
            api: (info: any) => APIS.updateSctnInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00059" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
                navigate(`${URLS.ptli0918003q}/${cstmOrgzCd}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00022" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
    };

    const handler = {
        onListBtnClick: () => {
            navigate(`${URLS.ptli0918001q}?menuId=${menuId}`);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.sctnInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.sctnInfo.handleSubmit(
                () => {
                    const data = form.sctnInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.updateSctnInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.sctnInfo.errors), form.sctnInfo.isSubmitted);
                },
            )();
        },
    };

    useEffect(() => {
        fetch.getSctnInfo.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzCd} edit={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmTz} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmEn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmKo} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section></Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button
                        variant="secondary"
                        onClick={() => {
                            navigate(`${URLS.ptli0918003q}/${cstmOrgzCd}`);
                        }}
                    >
                        {t("B_PRE")}
                    </Layout.Button>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
